import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import SchemaOrg from "@/components/feature/SchemaOrg";
import Hero from "./components/Hero";
import TrustBadges from "./components/TrustBadges";
import CategoryDropdown from "./components/CategoryDropdown";
import CategoryGrid from "./components/CategoryGrid";
import ContentSection from "./components/ContentSection";
import ArticleCTA from "./components/ArticleCTA";
import FAQSection from "./components/FAQSection";

const siteUrl = import.meta.env.VITE_SITE_URL;
const logoUrl = "https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/d367cf6745ee47f3fc82c76d3a54c50c.png";

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <TrustBadges />
        <CategoryDropdown />
        <CategoryGrid />
        <ContentSection />
        <ArticleCTA />
        <FAQSection />
      </main>
      <Footer />

      <SchemaOrg
        data={{
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "WebSite",
              "name": "CSSBuy Spreadsheet",
              "url": siteUrl,
              "description": "The ultimate CSSBuy Spreadsheet library with comprehensive guides, category links, shopping tips, and expert recommendations.",
              "potentialAction": {
                "@type": "SearchAction",
                "target": siteUrl + "/search?q={search_term_string}",
                "query-input": "required name=search_term_string",
              },
            },
            {
              "@type": "Organization",
              "name": "CSSBuy Spreadsheet",
              "url": siteUrl,
              "logo": logoUrl,
              "description": "The ultimate CSSBuy Spreadsheet library with comprehensive guides, category links, shopping tips, and expert recommendations.",
            },
          ],
        }}
      />
    </>
  );
}